import React from 'react';

const UserTasksSkeleton: React.FC = () => {
  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <div className="overflow-x-auto flex-1">
        <table className="w-full">
          <thead className="sticky top-0 bg-white dark:bg-black z-10">
            <tr className="text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              <th className="px-6 py-2.5">Task Name</th>
              <th className="px-6 py-2.5">Session ID</th>
              <th className="px-6 py-2.5">Tokens (In/Out)</th>
              <th className="px-6 py-2.5">Cache (R/W)</th>
              <th className="px-6 py-2.5">Cost</th>
              <th className="px-6 py-2.5">Timestamp</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-[#1F2937]">
            {[...Array(5)].map((_, i) => (
              <tr key={i} className="relative overflow-hidden">
                <td className="px-6 py-2.5">
                  <div className="h-4 bg-gray-200 dark:bg-[#1F2937] rounded w-3/4 animate-pulse" />
                </td>
                <td className="px-6 py-2.5">
                  <div className="h-4 bg-gray-200 dark:bg-[#1F2937] rounded w-1/2 animate-pulse" />
                </td>
                <td className="px-6 py-2.5">
                  <div className="h-4 bg-gray-200 dark:bg-[#1F2937] rounded w-2/3 animate-pulse" />
                </td>
                <td className="px-6 py-2.5">
                  <div className="h-4 bg-gray-200 dark:bg-[#1F2937] rounded w-1/2 animate-pulse" />
                </td>
                <td className="px-6 py-2.5">
                  <div className="h-4 bg-gray-200 dark:bg-[#1F2937] rounded w-1/3 animate-pulse" />
                </td>
                <td className="px-6 py-2.5">
                  <div className="h-4 bg-gray-200 dark:bg-[#1F2937] rounded w-2/3 animate-pulse" />
                </td>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Skeleton */}
      <div className="mt-4 flex items-center justify-between flex-shrink-0">
        <div className="h-4 bg-gray-200 dark:bg-[#1F2937] rounded w-48 animate-pulse" />
        <div className="flex gap-2">
          <div className="h-8 w-20 bg-gray-200 dark:bg-[#1F2937] rounded animate-pulse" />
          <div className="h-8 w-20 bg-gray-200 dark:bg-[#1F2937] rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default UserTasksSkeleton;